/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Header menu — hamburger, submenus, search toggle, WCAG keyboard nav.
 * Migrated from dpss-header-menu.js (262 lines) — FULL production version.
 */

export function initHeaderMenu(): void {
  const menuSm = document.getElementById("menuSm");
  const hamburger = document.getElementById("shomMenuSm");
  const closeMenuBtns = document.querySelectorAll<HTMLElement>(".closeMenuSm");
  const backMenuBtns = document.querySelectorAll<HTMLElement>(".backMenu");

  // ── showSubSubmenu toggle ──────────────────────────────────
  document.querySelectorAll<HTMLElement>(".showSubSubmenu").forEach((el) => {
    el.addEventListener("click", function (this: HTMLElement) {
      this.classList.toggle("active");
    });
  });

  // ── showSubmenu toggle + keyboard ──────────────────────────
  document.querySelectorAll<HTMLElement>(".showSubmenu").forEach((el) => {
    el.addEventListener("click", function (this: HTMLElement) {
      if (this.classList.contains("active")) {
        this.classList.remove("active");
        this.setAttribute("aria-expanded", "false");
      } else {
        document.querySelectorAll(".showSubmenu").forEach((s) => s.classList.remove("active"));
        this.classList.add("active");
        this.setAttribute("aria-expanded", "true");
      }
    });
    el.addEventListener("keydown", function (this: HTMLElement, ev: KeyboardEvent) {
      if (ev.key === "Enter") {
        const backBtn = this.nextElementSibling?.querySelector<HTMLElement>(".backMenu");
        this.setAttribute("aria-expanded", "true");
        if (backBtn) setTimeout(() => backBtn.focus(), 300);
      }
    });
  });

  // ── Hamburger open (click + keypress) ──────────────────────
  if (hamburger && menuSm) {
    hamburger.addEventListener("click", () => {
      menuSm.classList.add("active");
      menuSm.setAttribute("tabindex", "0");
      hamburger.setAttribute("aria-expanded",
        hamburger.getAttribute("aria-expanded") === "true" ? "false" : "true");
      document.body.classList.add("active");
    });
    hamburger.addEventListener("keypress", (ev: KeyboardEvent) => {
      if (ev.key === "Enter") {
        menuSm.classList.add("active");
        menuSm.setAttribute("tabindex", "0");
        document.body.classList.add("active");
        hamburger.setAttribute("aria-expanded",
          hamburger.getAttribute("aria-expanded") === "true" ? "false" : "true");
        const closeBtn = menuSm.querySelector<HTMLElement>(".closeMenuSm");
        if (closeBtn) setTimeout(() => closeBtn.focus(), 300);
      }
    });
  }

  // ── backMenu handlers (click + keypress) ───────────────────
  backMenuBtns.forEach((btn) => {
    btn.addEventListener("click", function (this: HTMLElement) {
      const submenu = this.closest(".submenu");
      if (submenu?.previousElementSibling) {
        submenu.previousElementSibling.classList.remove("active");
      }
      hamburger?.setAttribute("aria-expanded", "false");
    }, false);
    btn.addEventListener("keypress", function (this: HTMLElement, ev: KeyboardEvent) {
      if (ev.key === "Enter") {
        const submenu = this.closest(".submenu");
        if (submenu?.previousElementSibling) {
          submenu.previousElementSibling.classList.remove("active");
          submenu.previousElementSibling.setAttribute("aria-expanded", "false");
        }
        const closeBtn = menuSm?.querySelector<HTMLElement>(".closeMenuSm");
        if (closeBtn) setTimeout(() => closeBtn.focus(), 300);
      }
    }, false);
  });

  // ── closeMenuSm handlers (click + keypress) ────────────────
  closeMenuBtns.forEach((btn) => {
    btn.addEventListener("click", function (this: HTMLElement) {
      if (this.id === "closeSearch") return;
      if (menuSm) { menuSm.classList.remove("active"); menuSm.removeAttribute("tabindex"); }
      hamburger?.setAttribute("aria-expanded", "false");
      document.querySelectorAll(".showSubmenu").forEach((s) => s.classList.remove("active"));
      document.body.classList.remove("active");
    }, false);
    btn.addEventListener("keypress", function (this: HTMLElement, ev: KeyboardEvent) {
      if (ev.key === "Enter") {
        if (this.id === "closeSearch") return;
        if (menuSm) { menuSm.classList.remove("active"); menuSm.removeAttribute("tabindex"); }
        hamburger?.setAttribute("aria-expanded", "false");
        document.querySelectorAll(".showSubmenu").forEach((s) => s.classList.remove("active"));
        document.body.classList.remove("active");
        if (hamburger) setTimeout(() => hamburger.focus(), 300);
      }
    }, false);
  });

  // ── Close submenu on outside click ─────────────────────────
  document.addEventListener("mouseup", (ev: MouseEvent) => {
    let clickedInside = false;
    document.querySelectorAll(".submenu").forEach((sub) => {
      if (sub.contains(ev.target as Node)) clickedInside = true;
    });
    document.querySelectorAll(".menu").forEach((m) => {
      if (m.contains(ev.target as Node)) clickedInside = true;
    });
    if (!clickedInside) {
      document.querySelectorAll(".showSubmenu").forEach((s) => s.classList.remove("active"));
    }
  });

  // ── Search toggle (KMU: .js-search-toggle → #searchFormWrap) ──
  const searchFormWrap = document.getElementById("searchFormWrap");
  const closeSearchBtn = document.getElementById("closeSearch");

  document.querySelectorAll<HTMLElement>(".js-search-toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (searchFormWrap) {
        const isVisible = searchFormWrap.style.display === "block";
        searchFormWrap.style.display = isVisible ? "none" : "block";
        if (!isVisible) {
          const input = searchFormWrap.querySelector<HTMLElement>(".input");
          input?.focus();
        }
      }
    });
  });

  if (closeSearchBtn) {
    closeSearchBtn.addEventListener("click", () => {
      if (searchFormWrap) searchFormWrap.style.display = "none";
    });
  }

  // ── show_more menu overflow ────────────────────────────────
  const menuNav = document.querySelector<HTMLElement>("#menuDesktop .menu");
  const showMoreBtn = document.getElementById("show_more");
  let hiddenLinks: HTMLElement[] | undefined;

  function calcMenuOverflow(): void {
    if (!menuNav) return;
    menuNav.querySelectorAll<HTMLElement>(".showSubmenu").forEach((link) => {
      link.setAttribute("tabindex", "0");
    });
  }

  if (menuNav && showMoreBtn) {
    showMoreBtn.addEventListener("click", () => {
      menuNav.classList.toggle("active");
      showMoreBtn.classList.toggle("active");
      if (menuNav.classList.contains("active")) {
        showMoreBtn.setAttribute("aria-expanded", "true");
        if (hiddenLinks?.length) {
          hiddenLinks[0]!.focus();
          hiddenLinks.forEach((l) => l.setAttribute("tabindex", "0"));
        }
      } else {
        showMoreBtn.setAttribute("aria-expanded", "false");
        hiddenLinks?.forEach((l) => l.setAttribute("tabindex", "-1"));
        menuNav.querySelectorAll(".showSubmenu").forEach((link) => {
          link.classList.remove("active");
        });
      }
    });
    calcMenuOverflow();
    window.addEventListener("resize", calcMenuOverflow);
  }

  // ── WCAG: Escape key — close submenu/search/mobile menu ────
  document.addEventListener("keydown", (ev: KeyboardEvent) => {
    if (ev.key === "Escape") {
      // Close search
      const searchWrap = document.getElementById("searchFormWrap");
      if (searchWrap?.style.display === "block") {
        searchWrap.style.display = "none";
        const searchToggle = document.querySelector<HTMLElement>(".js-search-toggle");
        searchToggle?.focus();
        return;
      }
      // Close active submenu
      const activeSubmenu = document.querySelector<HTMLElement>(".showSubmenu.active");
      if (activeSubmenu) {
        activeSubmenu.classList.remove("active");
        activeSubmenu.setAttribute("aria-expanded", "false");
        activeSubmenu.focus();
        return;
      }
      // Close mobile menu
      if (menuSm?.classList.contains("active")) {
        menuSm.classList.remove("active");
        menuSm.removeAttribute("tabindex");
        document.body.classList.remove("active");
        if (hamburger) {
          hamburger.setAttribute("aria-expanded", "false");
          hamburger.focus();
        }
      }
    }
  });

  // ── WCAG: Arrow key navigation for desktop menu ────────────
  const desktopMenu = document.querySelector<HTMLElement>(
    ".menu-desktop__wrap .menu, .menu-desktop-wrap .menu",
  );
  if (desktopMenu) {
    desktopMenu.addEventListener("keydown", (ev: KeyboardEvent) => {
      const menuItems = Array.from(
        desktopMenu.querySelectorAll<HTMLElement>(":scope > li > a, :scope > li > .showSubmenu"),
      );
      const idx = menuItems.indexOf(document.activeElement as HTMLElement);
      if (idx === -1) return;

      if (ev.key === "ArrowRight" || ev.key === "ArrowDown") {
        ev.preventDefault();
        menuItems[(idx + 1) % menuItems.length]!.focus();
      } else if (ev.key === "ArrowLeft" || ev.key === "ArrowUp") {
        ev.preventDefault();
        menuItems[(idx - 1 + menuItems.length) % menuItems.length]!.focus();
      }
    });
  }

  // ── WCAG: Focus trap in mobile menu ────────────────────────
  if (menuSm) {
    menuSm.addEventListener("keydown", (ev: KeyboardEvent) => {
      if (ev.key !== "Tab") return;
      const focusable = menuSm!.querySelectorAll<HTMLElement>(
        'a[href], button, [tabindex]:not([tabindex="-1"])',
      );
      if (focusable.length === 0) return;
      const first = focusable[0]!;
      const last = focusable[focusable.length - 1]!;
      if (ev.shiftKey) {
        if (document.activeElement === first) {
          ev.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          ev.preventDefault();
          first.focus();
        }
      }
    });
  }
}
